import { decodeBase64, encodeBase64 } from "./decoder.utils";

export const removeGraphqlPrefixFromId = (id: string) =>
	encodeBase64(decodeBase64(id).split(":").slice(1).join(":"));
